import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Modal from '@jobcase/react_pattern_library/components/Modal/ModalRebrand';
import rebrandStyles from '@jobcase/react_pattern_library/styles/rebrand';

const ModalStyled = styled(Modal)`
  && {
    margin-bottom: ${rebrandStyles.spacing.tiny}px;
    padding: 0;
    top: 120px;
    width: 620px;

    ${({ isMobile, backgroundColor }) => (isMobile && css`
      background-color: ${backgroundColor || rebrandStyles.color.jobcaseWhiteColor};
      border-radius: 0;
      border: none;
      margin-bottom: 0;
      min-height: 100%;
      top: 0;
      width: 100%;

      &&.create-mobile-modal {
        padding-top: ${rebrandStyles.spacing.large + 1}px;

        .mobile-modal-header {
          margin: 0;
          position: fixed;
          top: 0;
        }
      }
    `)}

    .empty-modal {
      ${({ isMobile, isPrivateView }) => (isMobile && !isPrivateView && css`
        min-height: calc(100vh - ${rebrandStyles.spacing.tiny * 3}px);
      `)}

      @media (min-width: ${rebrandStyles.breakpoint.md}) {
        max-height: ${({ spacing }) => `calc(100vh - ${spacing}px)`};
        min-height: auto;
        overflow-y: auto;
      }
    }
  }

  &&.preview-notification-mobile {
    border-radius: 0;
    border: none;
    height: 100vh;
    top: 61px;
    width: auto;
  }

  &&.exit-modal {
    max-width: 380px;
    padding: ${rebrandStyles.spacing.tiny * 2}px 30px;
  }

  &&.event-desktop-modal,
  &&.hub-desktop-modal,
  &&.job-desktop-modal,
  &&.permissions-desktop-modal {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    top: 50px;
    width: 660px;

    ${({ minWidth }) => (minWidth && css`
      width: ${minWidth}px;
    `)}
  }

  @media (min-width: ${rebrandStyles.breakpoint.md}) {
    &&.filters-desktop-modal {
      max-height: calc(100vh - 100px);
      overflow-y: auto;
      top: 50px;
      width: 660px;
    }

    &&.credit-card-desktop-modal {
      max-height: calc(100vh - 100px);
      overflow-y: auto;
      top: 50px;
      width: 640px;
    }
  }
`;

const MobileModal = ({
  isMobile,
  isVisible,
  onClose,
  children,
  backgroundColor,
  className,
  hasCloseButton,
  closeOnMaskClick,
  mobileNotficationClass,
  minWidth,
  hasBlurredMask,
}) => (
  <ModalStyled
    isMobile={isMobile}
    isVisible={isVisible}
    hasCloseButton={hasCloseButton}
    onClose={onClose}
    backgroundColor={backgroundColor}
    className={className}
    closeOnMaskClick={closeOnMaskClick}
    spacing={340}
    mobileNotficationClass={mobileNotficationClass}
    minWidth={minWidth}
    hasBlurredMask={hasBlurredMask}
  >
    {children}
  </ModalStyled>
);

MobileModal.propTypes = {
  isMobile: PropTypes.bool,
  isVisible: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  closeOnMaskClick: PropTypes.bool,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  mobileNotficationClass: PropTypes.string,
  minWidth: PropTypes.number,
  children: PropTypes.node,
  onClose: PropTypes.func,
  hasBlurredMask: PropTypes.bool,
};

MobileModal.defaultProps = {
  isMobile: false,
  isVisible: false,
  hasCloseButton: false,
  closeOnMaskClick: true,
  backgroundColor: null,
  className: null,
  mobileNotficationClass: null,
  minWidth: null,
  children: null,
  onClose: null,
  hasBlurredMask: false,
};

export default MobileModal;
